//初始化数据
import Vue from 'vue'

const state = {
    isChildrenCollapsed: false,
}

//getter
const getters = {
    isChildrenCollapsed: function(state) {
        state.isChildrenCollapsed = sessionStorage.getItem('isChildrenCollapsed') || false;
        return state.isChildrenCollapsed
    },
}

//action
const actions = {
    setIsChildrenCollapsed({ commit }, u) {
        commit('SET_ISCC', u)
    },
}

//mutation
const mutations = {
    SET_ISCC(state, i) {
        state.isChildrenCollapsed = i;
        sessionStorage.setItem('isChildrenCollapsed', i)
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
};